<template>
    <div class="vx-card p-6">
        <div class="vx-row">
            <div class="vx-col w-full">
                <h3>Danh sách đánh giá của khách hàng</h3>
            </div>
        </div>

        <div class="vx-row">
            <div class="vx-col lg:w-1/3 md:w-1/2 w-full mt-2">
                <label class="vs-input--label">Chi nhánh</label>
                <v-select v-model="selectedBranch" :options="branchOptions" name="branch" :clearable="false">
                    <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                </v-select>
            </div>
            <div class="vx-col lg:w-1/3 md:w-1/2 w-full mt-2">
                <label class="vs-input--label">Phòng ban</label>
                <v-select v-model="selectedDepartment" :options="departmentOptions" name="department" :clearable="false"
                          class="elipsisText">
                    <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                </v-select>
            </div>
            <div class="vx-col lg:w-1/3 md:w-1/2 w-full mt-2">
                <label class="vs-input--label">Bác sĩ</label>
                <v-select v-model="selectedDoctor" :options="doctorOptions" name="doctor" :clearable="false">
                    <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                </v-select>
            </div>
            <div class="vx-col lg:w-1/3 md:w-1/2 w-full mt-2">
                <label class="vs-input--label">Khách hàng</label>
                <v-select v-model="selectedCustomerValue" :options="paginated"
                          :clearable="false" :filterable="false"
                          @open="onOpen"
                          @close="onClose"
                          @search="searchCustomer" :reduce="item => item.value">
                    <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                    <template #list-footer>
                        <li ref="load" class="loader">
                            Loading more options...
                        </li>
                    </template>
                </v-select>
            </div>
            <div class="vx-col lg:w-1/3 md:w-1/2 w-full mt-2">
                <label class="vs-input--label">Trạng thái</label>
                <v-select v-model="selectedStatus" :options="statusOptions" name="status" :clearable="false"></v-select>
            </div>
            <div class="vx-col lg:w-1/3 md:w-1/2 w-full mt-2">
                <label class="vs-input--label">Chất lượng</label>
                <v-select v-model="selectedRate" :options="rateOptions" name="rate" :clearable="false"></v-select>
            </div>
            <div class="vx-col lg:w-1/3 md:w-1/2 w-full mt-2">
                <label class="vs-input--label">Thời gian</label>
                <date-range-picker ref="picker" :locale-data="{ format: 'dd/mm/yyyy' }" :opens="'right'"
                                   @update="dateRangePicker" v-model="dateRange" class="w-full">
                </date-range-picker>
            </div>
            <!-- <div class="vx-col lg:w-1/3 md:w-1/3 sm:w-1/2 w-full mt-4">
                <label class="vs-input--label">Tìm kiếm</label>
                <vs-input class="w-full" v-model="keySearch" placeholder="Tìm kiếm ..."></vs-input>
            </div> -->
            <div class="vx-col md:mt-2">
                <vs-button class="md:mt-6 mt-4" icon-pack="feather" icon="icon-search" color="primary"
                           @click="findAllFeedback">Tìm kiếm
                </vs-button>
            </div>
        </div>

        <ag-grid-vue style="height: 55vh" ref="agGridTable" :gridOptions="gridOptions"
                     class="ag-theme-material w-100 my-4 ag-grid-table" :columnDefs="columnDefs"
                     :defaultColDef="defaultColDef"
                     :rowData="feedbackData" :animateRows="true" :pagination="true"
                     :localeText="{ noRowsToShow: this.$t('menuCustomer.noRowsToShow') }" :onGridReady="onGridReady"
                     :suppressPaginationPanel="true">
        </ag-grid-vue>

        <div class="mt-4 flex flex-wrap" v-if="feedbackData.length > 0">
            <div class="">
                <div class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 flex flex-wrap">
                    <span class="my-auto mr-2">Số phần tử / trang:</span>
                    <vs-dropdown vs-trigger-click class="cursor-pointer">
                        <div
                            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium vx-col">
                                <span class="mr-2">
                                    {{
                                        feedbackData.length - currentPage * pageSize > 0 ? currentPage *
                                            pageSize
                                            : feedbackData.length
                                    }} /
                                    {{ totalElements }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
                        </div>
                        <vs-dropdown-menu>
                            <vs-dropdown-item @click="changePageSize(20)">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="changePageSize(30)">
                                <span>30</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="changePageSize(50)">
                                <span>50</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="changePageSize(100)">
                                <span>100</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>
            </div>
            <div class="ml-auto">
                <vs-pagination class="" :total="totalPages" v-model="currentPage" @change="loadPageFeedback"/>
            </div>
        </div>
    </div>
</template>

<script>

import vSelect from 'vue-select';
import {AgGridVue} from "ag-grid-vue";
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';
import moment from "moment";
import Pagination from "../../../ui-elements/Pagination.vue";
import DateRangePicker from '../../../../components/vue2-daterange-picker/components/DateRangePicker.vue';
import CellRendererRate from './cell-renderer/CellRendererRate.vue';
import CellRendererActions from './cell-renderer/CellRendererActions.vue';
import CellRendererStatus from './cell-renderer/CellRendererStatus.vue';

export default {
    data() {
        return {
            feedbackData: [],
            // AgGrid
            gridApi: null,
            gridOptions: {},
            defaultColDef: {
                resizable: true,
            },
            columnDefs: [
                {
                    headerName: this.$t('menuCustomer.stt'),
                    field: 'stt',
                    width: 80,
                    suppressSizeToFit: true
                },
                {
                    headerName: 'Khách hàng',
                    field: 'customerName',
                    width: 250,
                    resizable: true,
                    suppressSizeToFit: true
                },
                {
                    headerName: this.$t('news.content'),
                    field: 'content',
                    width: 250,
                    resizable: true,
                    suppressSizeToFit: true
                },
                // {
                //     headerName: 'Phòng ban',
                //     field: 'departmentName',
                //     width: 200,
                // },
                {
                    headerName: 'Nhóm dịch vụ',
                    field: 'serviceName',
                    width: 250,
                    resizable: true,
                    suppressSizeToFit: true
                },
                {
                    headerName: this.$t('menuCustomer.dateCreated'),
                    field: 'created_at_display',
                    width: 200,
                    resizable: true,
                    suppressSizeToFit: true
                },
                {
                    headerName: this.$t('menuOrganization.status'),
                    field: 'status',
                    width: 150,
                    cellRendererFramework: 'CellRendererStatus',
                    resizable: true,
                    suppressSizeToFit: true
                },
                {
                    headerName: 'Chất lượng',
                    field: 'rate',
                    width: 200,
                    cellRendererFramework: 'CellRendererRate',
                    resizable: true,
                    suppressSizeToFit: true,
                },
                {
                    headerName: this.$t('button.actions'),
                    field: 'actions',
                    width: 150,
                    cellRendererFramework: 'CellRendererActions',
                    resizable: true,
                    suppressSizeToFit: true,
                },
            ],
            pageNumber: 0,
            pageSize: 20,
            totalPages: 0,
            currentPage: 1,
            totalElements: 0,
            branchOptions: [],
            selectedBranchValue: null,
            departmentOptions: [
                {value: null, label: 'Tất cả'}
            ],
            selectedDepartmentValue: null,
            doctorOptions: [
                {value: null, label: 'Tất cả'}
            ],
            selectedDoctorValue: null,
            customerOptions: [],
            selectedCustomerValue: 'null',
            dateRange: {
                startDate: new Date(new Date().setMonth(new Date().getMonth() - 1)).setUTCHours(0, 0, 0, 0),
                // startDate: new Date().setUTCHours(0, 0, 0, 0),
                endDate: new Date().setUTCHours(16, 59, 59, 999)
            },
            // keySearch: null,
            statusOptions: [
                {value: null, label: 'Tất cả'},
                {value: 1, label: 'Chờ xử lý'},
                {value: 2, label: 'Đã xử lý'}
            ],
            selectedstatusValue: null,
            selectedRateValue: null,
            rateOptions: [
                {value: null, label: 'Tất cả'},
                {value: 1, label: '1 sao'},
                {value: 2, label: '2 sao'},
                {value: 3, label: '3 sao'},
                {value: 4, label: '4 sao'},
                {value: 5, label: '5 sao'}
            ],
            pageNumberSelectCustomer: 0,
            pageSizeSelectCustomer: 20,
            observer: null,
            limit: 20,
            search: '',
            typingSearchCustomer: null,
            textTypingSearch: null,
            showListCustomer: false,
        }
    },

    components: {
        vSelect,
        AgGridVue,
        Pagination,
        DateRangePicker,
        CellRendererRate,
        CellRendererActions,
        CellRendererStatus,
    },

    computed: {
        selectedBranch: {
            get() {
                return {
                    label: this.getLabelString(this.branchOptions.find(x => x.value === this.selectedBranchValue)),
                    value: this.branchOptions.find(x => x.value === this.selectedBranchValue)
                }
            },
            set(obj) {
                this.selectedBranchValue = obj ? obj.value : null;
                if (this.selectedBranchValue) {
                    this.getDepartmentData();
                    this.getDoctorData();
                }
            }
        },
        selectedDepartment: {
            get() {
                return {
                    label: this.getLabelString(this.departmentOptions.find(x => x.value === this.selectedDepartmentValue)),
                    value: this.departmentOptions.find(x => x.value === this.selectedDepartmentValue)
                }
            },
            set(obj) {
                this.selectedDepartmentValue = obj ? obj.value : null;
                this.getDoctorData();
            }
        },
        selectedDoctor: {
            get() {
                return {
                    label: this.getLabelString(this.doctorOptions.find(x => x.value === this.selectedDoctorValue)),
                    value: this.doctorOptions.find(x => x.value === this.selectedDoctorValue)
                }
            },
            set(obj) {
                this.selectedDoctorValue = obj ? obj.value : null;
            }
        },
        // selectedCustomer: {
        //     get() {
        //         return {
        //             label: this.getLabelString(this.customerOptions.find(x => x.value === this.selectedCustomerValue)),
        //             value: this.customerOptions.find(x => x.value === this.selectedCustomerValue)
        //         }
        //     },
        //     set(obj) {
        //         this.selectedCustomerValue = obj ? obj.value : null;
        //     }
        // },
        selectedStatus: {
            get() {
                let obj = this.statusOptions.find(x => x.value === this.selectedstatusValue);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectedstatusValue = obj ? obj.value : null;
            }
        },
        selectedRate: {
            get() {
                let obj = this.rateOptions.find(x => x.value === this.selectedRateValue);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectedRateValue = obj ? obj.value : null;
            }
        },

        filtered() {
            return this.customerOptions;
        },
        paginated() {
            return this.filtered.slice(0, this.limit);
        },
    },

    watch: {
        '$store.state.windowWidth'(val) {
            if (val > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },
        '$store.state.reduceButton'() {
            setTimeout(() => {
                this.gridApi.sizeColumnsToFit();
            }, 650);
        },
    },

    async created() {

        let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
        this.branchOptions = branchList.map(x => {
            return {label: x.organizationBranchName, value: x.id}
        });

        this.branchOptions.unshift({value: null, label: 'Tất cả'});

        this.getCustomerData();
        this.findAllFeedback();
    },

    methods: {
        onGridReady() {
            if (this.$store.state.windowWidth > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },

        loadPageFeedback: function (currentPage) {
            if (this.pageNumber !== parseInt(currentPage) - 1) {
                this.pageNumber = parseInt(currentPage) ? parseInt(currentPage) - 1 : 0;
                this.findAllFeedback();
            }
        },

        changePageSize(number) {
            this.pageSize = number;
            this.pageNumber = 0;
            this.currentPage = 1;
            this.findAllFeedback();
        },

        dateRangePicker: function () {
            this.dateRange.startDate = new Date(this.dateRange.startDate.setUTCHours(0, 0, 0, 0));
            this.dateRange.endDate = new Date(this.dateRange.endDate.setUTCHours(16, 59, 59, 999));
        },

        getLabelString(object) {
            return (object && object.label) || 'Chưa xác định';
        },

        getDepartmentData() {
            return new Promise((resolve, reject) => {
                let body = {
                    organizationBranchId: this.selectedBranchValue,
                }

                this.departmentOptions = [];

                this.$vs.loading();
                this.$crm.post('/department/find-by-condition', body).then(res => {
                    if (res.data && res.data.length > 0) {
                        this.departmentOptions = res.data.map(el => {
                            return {
                                value: el.id,
                                label: el.departmentName
                            }
                        });
                    }
                    this.departmentOptions.unshift({value: null, label: 'Tất cả'});
                    resolve();
                    this.$vs.loading.close();
                }).catch(err => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        getDoctorData() {
            return new Promise((resolve, reject) => {
                let url = '/beauty-booking/get-list-doctor-department';
                if (this.selectedBranchValue) {
                    url += '?organizationBranchId=' + this.selectedBranchValue
                }
                if (this.selectedDepartmentValue) {
                    url += '&departmentId=' + this.selectedDepartmentValue
                }

                this.doctorOptions = [];

                this.$vs.loading();
                this.$crm.get(url).then(res => {
                    if (res.data.data && res.data.data.length > 0) {
                        this.doctorOptions = res.data.data.map(el => {
                            return {
                                value: el.id,
                                label: el.fullName
                            }
                        });
                    }
                    this.doctorOptions.unshift({value: null, label: 'Tất cả'})
                    resolve();
                    this.$vs.loading.close();
                }).catch(err => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        getCustomerData() {
            this.$vs.loading();
            let url = '/loyalty/customer/find'
            if (this.textTypingSearch != this.search) {
                this.textTypingSearch = this.search;
                this.customerOptions = [
                    {value: 'null', label: 'Tất cả'}
                ];
            }
            url += `?pageNumber=${this.pageNumberSelectCustomer}&pageSize=${this.pageSizeSelectCustomer}`;
            if (this.textTypingSearch) url += `&keySearch=${this.textTypingSearch}`;
            this.$vs.loading();
            this.$crm.get(url).then(res => {
                if (res.data.content && res.data.content.length > 0) {
                    let customer = res.data.content.map(el => {
                        return {
                            value: el.id,
                            label: el.phoneNumber + ' - ' + el.fullName
                        }
                    });
                    this.customerOptions.push(...customer);
                }
                this.$vs.loading.close();
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },

        findAllFeedback() {
            let userInfo = JSON.parse(localStorage.getItem('userInfo'));
            let payload = {
                customerId: this.selectedCustomerValue,
                departmentId: this.selectedDepartmentValue,
                organizationBranchId: this.selectedBranchValue ? this.selectedBranchValue : userInfo.organizationBranchId,
                endDate: new Date(this.dateRange.endDate).toISOString(),
                // keySearch: this.keySearch,
                performerId: this.selectedDoctorValue,
                startDate: new Date(this.dateRange.startDate).toISOString(),
                status: this.selectedstatusValue,
                rate: this.selectedRateValue,
                pageNumber: this.pageNumber,
                pageSize: this.pageSize,
            };

            this.$vs.loading();
            this.$crm.post('/beauty-booking-feedback/find-by-condition', payload).then(res => {
                this.feedbackData = res.data.content.map(el => {
                    el.stt = this.pageSize * this.pageNumber + res.data.content.indexOf(el) + 1;
                    el.customerName = el.loyaltyCustomer.fullName;
                    el.created_at_display = moment(el.createdDate).format('DD/MM/YYYY HH:mm');
                    // el.departmentName = el.departmentName;
                    let dataBooking = el.beautyBooking ? el.beautyBooking.beautyBookingDetails[0] : null;
                    if (dataBooking) {
                        let dataBookingDetails = dataBooking.beautyPackageCombo ? dataBooking.beautyPackageCombo : dataBooking.beautyServicePackage ? dataBooking.beautyServicePackage : null;
                        if (dataBookingDetails) el.serviceName = dataBookingDetails.name;
                    }
                    return el;
                });

                this.totalPages = res.data.totalPages;
                this.totalElements = res.data.totalElements;
                this.$vs.loading.close();
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },

        async onOpen() {
            this.showListCustomer = true;
            await this.$nextTick()
            this.observer.observe(this.$refs.load)
        },
        onClose() {
            this.search = '';
            this.pageNumberSelectCustomer = -1;
            this.showListCustomer = false;
            this.observer.disconnect()
        },
        async infiniteScroll([{isIntersecting, target}]) {
            if (isIntersecting) {
                const ul = target.offsetParent;
                const scrollTop = target.offsetParent.scrollTop;
                this.limit += 20;
                this.pageNumberSelectCustomer += 1;
                await this.$nextTick();
                ul.scrollTop = scrollTop;
                this.getCustomerData();
            }
        },

        searchCustomer(query) {
            if (this.showListCustomer) {
                if (this.search != query) this.pageNumberSelectCustomer = 0;
                this.search = query;
                clearTimeout(this.typingSearchCustomer);
                this.typingSearchCustomer = setTimeout(this.doneTypingSearch, 1500);
            }
        },

        async doneTypingSearch() {
            await this.getCustomerData();
            if (this.customerOptions.length === 1) this.selectedCustomerValue = 'null';
            await this.onOpen();
        },
    },

    mounted() {
        this.gridApi = this.gridOptions.api;
        this.observer = new IntersectionObserver(this.infiniteScroll);
    },
}
</script>
